// B-55 — the pure half of the Cierres shell's client selector.
//
// A Mantis business owning several cierre clients is the intended tenancy, not an error, and the
// panel endpoints answer 400 the moment one does and the request names none. These are the three
// decisions that choice needs, kept out of React so they can be read and tested on their own.
//
// Nothing here names a client. The list is the backend's (`listCierreClients`) and a
// `clientCode === "..."` in this file would be the start of a second list — the same rule
// `cierreManual.js` states for the worksheet. A client appears by being registered.

const PREFIJO = "cierres_client_";

// Per business, like `product_form_config_${clientId}` elsewhere: one browser can be logged into
// two cierres tenants over a session, and a single shared key would hand the second one the
// first one's client and earn a 403.
export function claveDeCliente(mantisBusinessId) {
  if (!mantisBusinessId) return null;
  return `${PREFIJO}${mantisBusinessId}`;
}

// The repo's option shape, the same `opcionDeOficina` produces. The `|| code` is what keeps a
// client registered without a name from rendering as a blank row. `logo` (the wordmark, for the
// selector's button) and `isotipo` (the square symbol, for its menu) are the signed URLs
// `listCierreClients` serves — they expire and are never stored — or null.
export function opcionDeCliente(cliente) {
  const code = cliente?.code || "";
  return {
    valor: code,
    etiqueta: cliente?.name || code,
    logo: cliente?.logoUrl || null,
    isotipo: cliente?.markUrl || null,
  };
}

// What stands in for a client's isotipo when it has none: the first letter of its first two words,
// or the first two letters of a one-word name ("Banco Agrario" -> "BA", "Bancamía" -> "BA").
export function inicialesDeCliente(etiqueta) {
  const palabras = String(etiqueta || "").trim().split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return "?";
  const letras = palabras.length > 1 ? palabras[0][0] + palabras[1][0] : palabras[0].slice(0, 2);
  return letras.toUpperCase();
}

// Which client the panel opens on.
//
// The remembered code only wins while it is **still in the list**: a client that was deactivated
// or moved to another business is answered with a 403, so honouring a stale code would leave the
// panel refusing to load with no way back. Falling to the first one — the backend orders them by
// code — always resolves.
export function clienteInicial(clientes, guardado) {
  const lista = (Array.isArray(clientes) ? clientes : []).filter((c) => c?.code);
  if (lista.length === 0) return "";
  if (guardado && lista.some((c) => c.code === guardado)) return guardado;
  return lista[0].code;
}

// What the selector reads while it waits, and after. Never empty: the list arrives one request
// after the shell paints, and a button with nothing in it reads as broken rather than as loading.
export function etiquetaDeCliente(clientes, clientCode) {
  const lista = Array.isArray(clientes) ? clientes : [];
  const elegido = lista.find((c) => c?.code && c.code === clientCode);
  if (elegido) return opcionDeCliente(elegido).etiqueta;
  return clientCode || "Cliente";
}
